function onReady (fn) {
    if (document.readyState !== 'loading') {
        fn()
        return
    }

    document.addEventListener('DOMContentLoaded', fn)
}

export default onReady